module.exports = __webpack_public_path__ + "img/HODO-Pro.79659286.png";